import { ApiService } from '../../../services/api'
import { meetingAdapter } from './meetingApiAdapters'
import {
  FetchMeetingRequest,
  MeetingAssistFeedbackRequest,
  MeetingAssistResponse,
  MeetingResponse,
  RegisterParticipantsRequest,
  RequestAssistNowRequest,
  UpdateAssistContextRequest,
  UploadAssistContextDocumentRequest,
} from './meetingApiInterfaces'

export const fetchMeeting = async (data: FetchMeetingRequest) => {
  const response = await ApiService.apiInstance.post<MeetingResponse>('/meetings/fetch', data)
  return meetingAdapter(response.data)
}

export const getMeeting = async (meetingId: string) => {
  const response = await ApiService.apiInstance.get<MeetingResponse>(`/meetings/${meetingId}`)
  return meetingAdapter(response.data)
}

export const getMeetings = async () => {
  const response = await ApiService.apiInstance.get<MeetingResponse[]>('/meetings')
  return response.data.map(meetingAdapter)
}

export const getMeetingAssist = async (meetingId: string, since?: string | null) => {
  const response = await ApiService.apiInstance.get<MeetingAssistResponse[]>(
    `/meetings/${meetingId}/assist`,
    { params: since ? { since } : undefined },
  )
  return response.data
}

export const requestAssistNow = async (meetingId: string, payload?: RequestAssistNowRequest) => {
  const response = await ApiService.apiInstance.post<{ ok: true }>(
    `/meetings/${meetingId}/assist/now`,
    payload ?? {},
  )
  return response.data.ok
}

export const submitAssistFeedback = async (
  meetingId: string,
  assistId: string,
  value: MeetingAssistFeedbackRequest['value'],
) => {
  const response = await ApiService.apiInstance.post<{ ok: true }>(
    `/meetings/${meetingId}/assist/${assistId}/feedback`,
    { value },
  )
  return response.data.ok
}

export const deleteMeeting = async (meetingId: string) => {
  await ApiService.apiInstance.delete(`/meetings/${meetingId}`)
}

export const startRecording = async (meetingId: string) => {
  const response = await ApiService.apiInstance.patch<MeetingResponse>(
    `/meetings/${meetingId}/start-recording`,
  )
  return meetingAdapter(response.data)
}

export const stopRecording = async (meetingId: string) => {
  const response = await ApiService.apiInstance.patch<MeetingResponse>(
    `/meetings/${meetingId}/stop-recording`,
  )
  return meetingAdapter(response.data)
}

export const regenerateSummary = async (meetingId: string) => {
  const response = await ApiService.apiInstance.patch<MeetingResponse>(
    `/meetings/${meetingId}/summary`,
  )
  return meetingAdapter(response.data)
}

export const resendFiles = async (meetingId: string, email?: string) => {
  const response = await ApiService.apiInstance.post<{ ok: true }>(
    `/meetings/${meetingId}/resend-files`,
    { email },
  )
  return response.data.ok
}

export const registerParticipants = async (
  meetingId: string,
  participants: RegisterParticipantsRequest,
) => {
  const response = await ApiService.apiInstance.post(
    `/meetings/${meetingId}/participants`,
    participants,
  )
  return meetingAdapter(response.data)
}

export const updateAssistContext = async (
  meetingId: string,
  payload: UpdateAssistContextRequest,
) => {
  const response = await ApiService.apiInstance.patch<MeetingResponse>(
    `/meetings/${meetingId}/assist-context`,
    payload,
  )
  return meetingAdapter(response.data)
}

export const uploadAssistContextDocument = async (
  meetingId: string,
  payload: UploadAssistContextDocumentRequest,
) => {
  const formData = new FormData()
  formData.append('file', payload.file)
  const response = await ApiService.apiInstance.post<MeetingResponse>(
    `/meetings/${meetingId}/assist-context/document`,
    formData,
  )
  return meetingAdapter(response.data)
}
